import { useTranslation } from 'react-i18next';

import { useCurrentCompany } from '@bonusly/who-am-i';

export const useBalanceData = () => {
	const company = useCurrentCompany();
	const { t } = useTranslation('components');

	const key = company.zero_point_bonuses ? 'rich_media.amount.zero_point_giving_description' : 'rich_media.amount.no_balance_description';

	return {
		description: t(key),
	};
};
